import { AddMember } from 'ui/icons';
import { Button } from 'ui/mobile-ds';
import { EmptyStateInvoices } from 'ui/mobile-ds/icons';

interface IProps {
  handleCtaClick: () => void;
}

const EmptyRequestHistory = ({ handleCtaClick }: IProps) => {
  return (
    <div className="flex items-center justify-center h-[100%]">
      <div className="flex flex-col items-center justify-center">
        <EmptyStateInvoices />
        <p className="mt-8 font-body text-mobile-text-hierarchy-2 text-sm font-normal">
          Looks like you don’t have any previous requests
        </p>
        <Button
          className="px-10 py-[14px] text-base font-body font-medium mt-9"
          intent="primary"
          onClick={handleCtaClick}
        >
          <AddMember /> Add Family
        </Button>
      </div>
    </div>
  );
};

export default EmptyRequestHistory;
